import { defineStore } from "pinia"
import { useStateStore } from "./state.store"
import Cookies from "js-cookie"
import { ref, watchEffect } from "vue"
import defineMainColor from "./utils/defineMainColor"
import { watch } from "vue"

type Theme = 'light' | 'dark'

function getSystemTheme() {
  return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

const localTheme = Cookies.get("themeClub") || getSystemTheme()

export const useUIStore = defineStore('UI', () => {
  const state = useStateStore()

  const theme = ref<Theme>(localTheme)

  function getTheme() {
    return theme.value;
  }

  function toogleTheme() {
    theme.value = getTheme() == "light" ? "dark" : "light";
  }

  function defineSiteTheme() {
    const s = state.settings
    const mainColor = s?.['main_color'] || state.site?.['main_color']
    defineMainColor(mainColor)

    const themeFixed = s?.['theme_fixed_painel'] || state.site?.['theme_fixed']
    const themeFixedColor = s?.['theme_fixed_painel_color'] || state.site?.['theme_fixed_color']
    if (themeFixed && themeFixedColor) {
      theme.value = themeFixedColor as Theme
    }
  }

  watch(() => theme.value, (newTheme) => {
    document.querySelector("html").setAttribute("data-theme", newTheme);
    Cookies.set("themeClub", newTheme, { expires: 365 });
  }, {
    immediate: true,
  })

  watchEffect(() => {
    defineSiteTheme()
  })

  function $reset() {
    theme.value = localTheme
  }

  return {
    theme,
    getTheme,
    toogleTheme,
    $reset,
  }
})
